import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" className={className}>
    <mask
      id="mask0_3993_26883"
      style={{ maskType: 'alpha' }}
      width="32"
      height="32"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H32V32H0z"></path>
    </mask>
    <g mask="url(#mask0_3993_26883)">
      <path
        fill="#000"
        d="M16 29.333c-3.09-.777-5.64-2.55-7.65-5.316-2.011-2.767-3.017-5.84-3.017-9.217V6.667l10.667-4 10.666 4V14.8c0 3.378-1.005 6.45-3.016 9.217-2.011 2.766-4.561 4.539-7.65 5.316zm0-2.8c2.31-.733 4.222-2.2 5.733-4.4C23.244 19.933 24 17.49 24 14.8V8.5l-8-3-8 3v6.3c0 2.689.755 5.133 2.266 7.333 1.511 2.2 3.423 3.667 5.734 4.4z"
      ></path>
      <path fill="#298842" d="M22.134 13.2L14.6 20.733l-4.7-4.7 1.9-1.9 2.8 2.8 5.634-5.633 1.9 1.9z"></path>
    </g>
  </svg>
);

export default Icon;
